import { DEFAULT_DELETE_PATH, STAFF_LIST_PATH, STAFF_ADD_PATH, STAFF_EDIT_PATH } from '../../constants/paths';
import {ActionWindow} from '../../components/action_window/action_window';
import {staffAction} from './actions';
import {StaffList, staffListLoader} from './staff_list';
import {Staff, staffAddLoader, staffEditLoader} from './staff';
import { AuthProvider } from '../../auth_provider';

const staffRoutes = [
  {
    path: STAFF_LIST_PATH.slice(1),
    element: <StaffList />,
    loader: staffListLoader,
    shouldRevalidate: ({ nextUrl, actionResult, formMethod }) => { 
        return AuthProvider.is_authenticated && nextUrl.pathname === STAFF_LIST_PATH && formMethod && (!actionResult || !actionResult.message);
    },
    children: [
      {
        path: `${DEFAULT_DELETE_PATH.slice(1)}:user_id`,
        element: <ActionWindow
            title="Deletar colaborador"
            titleOnLoading="Deletando colaborador"
            titleOnFail="Falha ao deletar colaborador"
            description="Todos os dados relacionados ao colaborador serão removidos"
            confirmText="Deletar colaborador"
            onCancelPath={STAFF_LIST_PATH}
            onFailPath={STAFF_LIST_PATH}
            onSuccessPath={STAFF_LIST_PATH}
            submitMethod="DELETE"
        />,
        action: staffAction
      }
    ]
  },
  {
      path: STAFF_ADD_PATH.slice(1),
      element: <Staff key="staff:add" isEdit={false} />,
      loader: staffAddLoader,
      shouldRevalidate: ({ formMethod }) => AuthProvider.is_authenticated && !formMethod,
      action: staffAction
  },
  {
      path: `${STAFF_EDIT_PATH.slice(1)}:user_id`,
      element: <Staff key="staff:edit" isEdit={true} />,
      loader: staffEditLoader,
      shouldRevalidate: ({ formMethod }) => AuthProvider.is_authenticated && !formMethod,
      action: staffAction
  },
];

export default staffRoutes;